import type { StaticPillVariant } from '@app/shared/vue/components/sf-static-pill/constants'
import type {
  UserAccess,
  UserColumn,
  UserList,
  UserRole,
  UserStatus,
} from '@app/application/user-management/types'

import { staticPillVariants } from '@app/shared/vue/components/sf-static-pill/constants'
import { userColumns } from '@app/application/user-management/types'

export const SKELETON_ROWS = 5

export const ADD_BUTTON_KEYS: Record<UserList, string> = {
  staff: 'user.add_staff',
  external: 'user.add_external',
}

export const EMPTY_STATE_KEYS: Record<UserList, string> = {
  staff: 'user.empty_states.staff',
  external: 'user.empty_states.external_contributor',
}

export const STAFF_COLUMNS: UserColumn[] = [
  userColumns.NAME,
  userColumns.STATUS,
  userColumns.ROLE,
  userColumns.ACCESS,
  userColumns.FILES,
  userColumns.LAST_LOGIN,
  userColumns.ACTIONS,
]

export const EXTERNAL_COLUMNS: UserColumn[] = STAFF_COLUMNS.filter(
  (column) => column !== userColumns.ACCESS
)

export const COLUMN_LABEL_KEYS: Record<UserColumn, string> = {
  [userColumns.NAME]: 'user.table.columns.name',
  [userColumns.STATUS]: 'user.table.columns.status',
  [userColumns.ROLE]: 'user.table.columns.role',
  [userColumns.ACCESS]: 'user.table.columns.access',
  [userColumns.FILES]: 'user.table.columns.client_files',
  [userColumns.LAST_LOGIN]: 'user.table.columns.last_login',
  [userColumns.ACTIONS]: 'user.table.columns.action',
}

// The design fixes these two columns, so the name has room for an avatar over two
// lines and the pencil sits clear of the right edge. The rest share what is left.
export const COLUMN_CLASSES: Partial<Record<UserColumn, string>> = {
  [userColumns.NAME]: 'tw-w-[240px]',
  [userColumns.ACTIONS]: 'tw-w-[81px]',
}

export const STATUS_VARIANTS: Record<UserStatus, StaticPillVariant> = {
  active: staticPillVariants.SUCCESS,
  unconfirmed: staticPillVariants.WARNING,
  deactivated: staticPillVariants.NEUTRAL,
}

export const STATUS_KEYS: Record<UserStatus, string> = {
  active: 'user.table.status.active',
  deactivated: 'user.table.status.deactivated',
  unconfirmed: 'user.table.status.unconfirmed',
}

export const ROLE_KEYS: Record<UserRole, string> = {
  admin: 'user.table.role.admin',
  contributor: 'user.table.role.contributor',
  pulse: 'user.table.role.pulse',
  staff: 'user.table.role.staff',
}

export const ACCESS_KEYS: Record<UserAccess, string> = {
  all_files: 'user.table.access.multifile',
  limited: 'user.table.access.limited',
}
